import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/home',
    name: 'Home',
    component: Home,
    redirect: "/shouye"
  },
  {
    path: '/tjQrcode',
    name: 'tjQrcode',
    meta: { title: "小程序码" },
    component: () => import('../views/xcxCheck/tjQrcode.vue')
  },
  {
    path: '/tjQrcodeWrite',
    name: 'tjQrcodeWrite',
    meta: { title: "社区码" },
    component: () => import('../views/xcxCheck/tjQrcodeWrite.vue')
  },
  {
    path: '/tjQrcodeSchool',
    name: 'tjQrcodeSchool',
    meta: { title: "小程序码" },
    component: () => import('../views/xcxCheck/tjQrcodeSchool.vue')
  },
  {
    path: '/tjListData',
    name: 'tjListData',
    meta: { title: "查体数据" },
    component: () => import('../views/xcxCheck/tjListData.vue')
  },
  {
    path: '/tjSubmitDatas',
    name: 'tjSubmitDatas',
    meta: { title: "查体信息上传" },
    component: () => import('../views/xcxCheck/tjSubmitDatas.vue')
  },
  {
    path: '/tjQrcodeSecondVisit',
    name: 'tjQrcodeSecondVisit',
    meta: { title: "小程序码" },
    component: () => import('../views/xcxCheck/tjQrcodeSecondVisit.vue')
  },
  {
    path: '/tjQrcodeCs',
    name: 'tjQrcodeCs',
    meta: { title: "小程序码" },
    component: () => import('../views/xcxCheck/tjQrcodeCs.vue')
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: "/shouye",
    children: [
      {
        path: '/shouye',
        name: 'shouye',
        component: () => import('../views/shouye.vue')
      },
      {
        path: '/address',
        name: 'address',
        component: () => import('../views/address.vue')
      },
      {
        path: '/guanyu',
        name: 'guanyu',
        component: () => import('../views/guanyu.vue')
      },
      {
        path: '/ceping',
        name: 'ceping',
        component: () => import('../views/ceping.vue'),
        redirect: "/shouye/test",
        children: [
          {
            path: '/shouye/test',
            name: 'test',
            component: () => import('../views/cepingchild/test.vue')
          },
          {
            path: '/shouye/type',
            name: 'type',
            component: () => import('../views/cepingchild/type.vue')
          }
        ]
      },

    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // 动态设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = '福音康复集团'; // 没有配置时的默认值
  }
  
  next();
});

export default router
